import { useMemo } from 'react';
import Country from '@tiendanube/common/src/enums/Country';
import { FEATURE_ORDERS_AUTO_CANCEL } from 'App/features';
import {
  useGetCountry,
  useStatusFeatureByKeyWithDefaultValue,
} from 'domains/Auth/hooks';
import { useKycStatus } from 'domains/NuvemPagoCommons/hooks/useKycStatus';

const countriesEnabledForAutoCancel = [Country.BR, Country.AR];

export function useIsOrdersAutoCancelEnabledForUpsell() {
  const { isKycRejected } = useKycStatus();
  const country = useGetCountry();
  const isEnabled = useMemo(
    () => countriesEnabledForAutoCancel.includes(country) && !isKycRejected,
    [country, isKycRejected],
  );
  return isEnabled;
}

export function useIsOrdersAutoCancelEnabled() {
  const { isKycRejected } = useKycStatus();
  const country = useGetCountry();
  const { isAvailable } = useStatusFeatureByKeyWithDefaultValue(
    FEATURE_ORDERS_AUTO_CANCEL,
    0,
  );
  const isEnabled = useMemo(
    () =>
      countriesEnabledForAutoCancel.includes(country) &&
      !isKycRejected &&
      isAvailable,
    [isKycRejected, isAvailable, country],
  );

  return isEnabled;
}
